<template>
    <span>
        <v-list-tile @click="mostrarCaixaDialogo">
            <v-list-tile-title>
                Reclassificar
            </v-list-tile-title>
        </v-list-tile>
        <v-dialog :max-width="Modal.Confirmacao.larguraMaxima" persistent v-model="visibilidadeDialogo">
            <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
                <v-card-title class="primary modal-title" primary-title>
                    <span><strong>{{itemOuLoteDescricao}}</strong> | Reclassificar Fornecedor</span>
                    <v-btn flat depressed @click="fecharCaixaDialogo">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0 az-form-content">
                    <div class="az-text mb-3">
                        <label>Fornecedor</label>
                        <p>{{razaoSocial}}</p>
                    </div>

                    <v-textarea v-model="motivoReclassificacao"
                                :error-messages="errors.collect('Motivo da Reclassificação ' + razaoSocial + ' item/Lote Id ' + itemOuLoteId)"
                                v-validate="'required'"
                                label="Motivo da Reclassificação"
                                :name="'Motivo da Reclassificação ' + razaoSocial + ' item/Lote Id ' + itemOuLoteId"
                                placeholder="Digite aqui seu motivo"
                                rows="3"
                                maxlength="1000"
                                class="required-field"
                                :counter="1000"/>
                </v-card-text>

                <v-card-actions class="px-3 py-2">
                    <v-btn color="botao-cancelar-color" flat outline @click="fecharCaixaDialogo">
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn id="botaoReclassificar" color="primary" depressed @click="reclassificar">
                        Reclassificar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>
import {Modal} from '@/core/constants'

export default {
    name: 'AcoesReclassificar',
    $_veeValidate: {
        validator: 'new'
    },
    props: ['itemOuLoteDescricao', 'razaoSocial', 'itemOuLoteId'],
    data() {
        return {
            visibilidadeDialogo: false,
            motivoReclassificacao: null,
            Modal
        }
    },
    methods: {
        async reclassificar() {
            await this.validarPreenchimento()
            this.$emit('reclassificar', this.motivoReclassificacao)
            this.fecharCaixaDialogo()
        },
        async validarPreenchimento() {
            const estaValidado = await this.$validator.validate('Motivo da Reclassificação ' + this.razaoSocial + ' item/Lote Id ' + this.itemOuLoteId)
            if (!estaValidado) {
                throw new Error('Preencha todos os campos obrigatórios.')
            }
        },
        mostrarCaixaDialogo() {
            setTimeout(() => {
                this.limparCampos()
                this.visibilidadeDialogo = true
            }, 500)
        },
        fecharCaixaDialogo() {
            this.limparCampos()
            this.visibilidadeDialogo = false
        },
        limparCampos() {
            this.motivoReclassificacao = null
            this.$validator.reset()
        }
    },
    destroyed() {
        this.fecharCaixaDialogo()
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base) !important
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important

    .required-field label:after
        content " *"
        color rgb(255, 98, 98)
</style>